import { DuotoneSvgProps } from './types';

export default function VolcanoSVG({
  primaryColor,
  secondaryColor,
}: DuotoneSvgProps) {
  return (
    // <!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      id="uuid-9371679f-88e3-4529-bdd4-d92bc2c66834"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <defs>
        <style type="text/css">
          .primary-markers&#123;fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:4.0441;stroke-miterlimit:10;&#125;
          .secondary-markers&#123;fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:4.0441;stroke-miterlimit:10;&#125;
        </style>
      </defs>
      <g style={{ fill: secondaryColor }} className="secondary-fill">
        <circle
          id="uuid-247c027a-c4f3-43cd-b8ad-5b0acabbbb06"
          className="secondary-markers"
          cx="102.16"
          cy="158.71"
          r="16.53"
        />
        <circle
          id="uuid-06c8372b-800d-432c-96d5-570272437a0a"
          className="secondary-markers"
          cx="66.53"
          cy="74.27"
          r="16.53"
        />
        <circle
          id="uuid-304b5760-fd4d-461c-a2ed-dc29e0c10452"
          className="secondary-markers"
          cx="418.92"
          cy="113.19"
          r="16.53"
        />
        <circle
          id="uuid-675120de-1bb4-465e-8289-fe1610035b74"
          className="secondary-markers"
          cx="112.06"
          cy="99.99"
          r="16.53"
        />
        <circle
          id="uuid-1b190dfd-66ca-4fb2-9e75-cb1a6eac55de"
          className="secondary-markers"
          cx="429.17"
          cy="66.93"
          r="16.53"
        />
        <circle
          id="uuid-9e236134-b0ae-43c2-9328-45f34f60517f"
          className="secondary-markers"
          cx="359.18"
          cy="143"
          r="16.53"
        />
      </g>
      <g style={{ fill: primaryColor }} className="primary-fill">
        <circle
          id="uuid-18e6e13c-7360-4834-84eb-e031109cb534"
          className="primary-markers"
          cx="336.93"
          cy="366.72"
          r="16.53"
        />
        <circle
          id="uuid-334a05a2-fccf-41b9-8a6c-ce655d481f61"
          className="primary-markers"
          cx="302.24"
          cy="278.58"
          r="16.53"
        />
        <circle
          id="uuid-c2d4adff-7de2-4811-bdc5-1894b3214948"
          className="primary-markers"
          cx="167.31"
          cy="247.56"
          r="16.53"
        />
        <circle
          id="uuid-55401210-f45d-4cab-be02-2f973d75d7ce"
          className="primary-markers"
          cx="161.75"
          cy="192.61"
          r="16.53"
        />
        <circle
          id="uuid-ffbcb7c6-01dd-4f22-ad9a-04da4a5a39ff"
          className="primary-markers"
          cx="294.24"
          cy="348.59"
          r="16.53"
        />
        <circle
          id="uuid-5206df54-aa60-4626-bd9c-1213ae7841d2"
          className="primary-markers"
          cx="130.95"
          cy="224.42"
          r="16.53"
        />
        <circle
          id="uuid-7c90729a-0cf3-42c4-8fe7-6c53bfecfa3b"
          className="primary-markers"
          cx="215.41"
          cy="386.99"
          r="16.53"
        />
        <circle
          id="uuid-b6ff35a5-0c5d-437d-8829-09cdcc8a70f7"
          className="primary-markers"
          cx="364.08"
          cy="199.67"
          r="16.53"
        />
        <circle
          id="uuid-ad93d606-1e89-448c-a2c4-b1dc5864bdd8"
          className="primary-markers"
          cx="165.47"
          cy="315.54"
          r="16.53"
        />
        <circle
          id="uuid-33ae6aae-f1f7-4414-adfe-cf997e5e8165"
          className="primary-markers"
          cx="204.22"
          cy="287.51"
          r="16.53"
        />
        <circle
          id="uuid-c0b62bec-8d4b-43a4-a766-1a4dceffb888"
          className="primary-markers"
          cx="333.28"
          cy="247.56"
          r="16.53"
        />
        <circle
          id="uuid-96314411-9f73-4ed4-8343-f0b0d6a0be69"
          className="primary-markers"
          cx="367.52"
          cy="272.89"
          r="16.53"
        />
        <circle
          id="uuid-368c8c70-6351-44d6-8fd5-9cd96f9760de"
          className="primary-markers"
          cx="129.69"
          cy="278.58"
          r="16.53"
        />
        <circle
          id="uuid-ee4b275e-7af4-4863-8518-b936007d9876"
          className="primary-markers"
          cx="336.93"
          cy="314.48"
          r="16.53"
        />
        <circle
          id="uuid-3f3d4098-30e1-4314-90a2-d03d6cf09065"
          className="primary-markers"
          cx="197.07"
          cy="342.06"
          r="16.53"
        />
        <circle
          id="uuid-557e71a7-5910-4c04-9937-78e1f7a5d22c"
          className="primary-markers"
          cx="162.75"
          cy="363.31"
          r="16.53"
        />
        <circle
          id="uuid-2db332d9-901e-485c-8663-be5b6ca4b150"
          className="primary-markers"
          cx="288.14"
          cy="401.45"
          r="16.53"
        />
        <circle
          id="uuid-24d87e1c-f2e2-407f-968c-7354c26eb11f"
          className="primary-markers"
          cx="250"
          cy="433.07"
          r="16.53"
        />
      </g>
    </svg>
  );
}
